export default {
    "path": "base_layout",
    "html": require('./layout/html').default,
    "css": require('./layout/css').default,
    "cssTablet": require('./layout/cssTablet').default,
    "cssMobile": require('./layout/cssMobile').default,
    "scss": require('./layout/scss').default,
    "scssTablet": require('./layout/scssTablet').default,
    "scssMobile": require('./layout/scssMobile').default,
    "js": require('./layout/js').default,
    "minJs": require('./layout/minJs').default
}